import { assetDictionary } from "@dinahmoe/dmafjs-assetloader";

import { visualEntities } from "../entities.js";
import { create } from "../helpers/elements.helper.js";
import { VisualSuperHtml } from "./visual-super.environment.js";

class MediaHtml extends VisualSuperHtml {
  setProps(eNode) {
    const type = eNode.props["media.type"];
    const assetId = eNode.props["media.assetId"];
    const element = assetDictionary.get(`assets.${type}.${assetId}`);

    if (!element) {
      console.error(`Asset ${assetId} of type ${type} not found.`);
      return;
    }

    element.style.pointerEvents = "auto";
    element.controls = eNode.props["media.controls"];
    element.muted = eNode.props["media.muted"];
    element.autoplay = eNode.props["media.autoPlay"];
    element.loop = eNode.props["media.loop"];

    eNode.element = create(eNode, element);

    super.setProps(eNode);
  }
}

const mediaHtml = new MediaHtml("visual:media");
visualEntities.set("visual:media", mediaHtml);
export { MediaHtml, mediaHtml };
